// extracted by mini-css-extract-plugin
module.exports = {"efbutton":"EFButton_efbutton__6oTfh"};